import React from 'react';

import { LinkOutlined } from '@ant-design/icons';

import MyCollapse from 'components/Collapse';
import type IProduct from 'interfaces/IProduct';
import type IUser from 'interfaces/IUser';
import Atention from 'scenes/Producer/Product/MyProducts/components/Atention';
import ShareableLinks from 'scenes/Producer/Product/MyProducts/components/ShareableLinks';

interface IProps {
  copiedCheckout?: () => void;
  product: IProduct;
  currentUser?: IUser;
}

const QuickViewLinks = ({ product, copiedCheckout }: IProps) => {
  return (
    <React.Fragment>
      <MyCollapse className='pb-1' title='Links' icon={<LinkOutlined style={{ fontSize: 16 }} />} arrow contentActive>
        <ShareableLinks copiedCheckout={copiedCheckout} productId={product.hash ?? product.id} />
        <Atention />
      </MyCollapse>
    </React.Fragment>
  );
};

export default QuickViewLinks;
